import { render } from "./BONotification.vue?vue&type=template&id=75ab3bb4&scoped=true&ts=true"
import script from "./BONotification.vue?vue&type=script&lang=ts"
export * from "./BONotification.vue?vue&type=script&lang=ts"

import "./BONotification.vue?vue&type=style&index=0&id=75ab3bb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ab3bb4"]])

export default __exports__